import { Outlet } from "react-router-dom";

const TeacherCourse = () => {
  return (
    <Outlet />
  );
};

export default TeacherCourse;
